import { useSupplierDashboardContext } from "./useSupplierDashboardContext";
import SupplierInfo from "./SupplierInfo";

export function SupplierDashboard() {
  const { supplier } = useSupplierDashboardContext()

  if (!supplier) {
    return <div>Loading...</div>;
  }
  return (
    <div className="relative w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="w-full grid grid-cols-1 lg:grid-cols-5 p-4">
        <SupplierInfo />
      </section>
    </div>
  )
}